// tokenManager.js
let adminToken = null;

export const setAdminToken = (token) => {
  adminToken = token;
};

export const getAdminToken = () => {
  return adminToken;
};

export const clearAdminToken = () => {
  adminToken = null;
};
